// زرّ «KPI» — يفتح لوحة المؤشرات من الحافة اليسرى الفعلية.
//
// للموظف: زرّ عائم ثابت في أسفل الحافة اليسرى، فلا يزاحم شيئًا في الشريط العلوي.
// وحمولة الموظف لا تحمل أرقامًا مالية أصلًا (الخادم لا يرسلها)، فالزرّ لا يكشف شيئًا.
import { useState } from 'react';
import { KpiPanel } from './KpiPanel.tsx';

/**
 * `header`: **في ترويسة الموبايل بجانب «تسجيل الخروج»** (المالك 04/10/2026: «ال kpi من الموبيل مبتظهرش ومش عارف افتحها») —
 * الزرّ العائم كان يقع تحت شريط التنقّل السفلي في الموبايل فلا يُرى ولا يُضغط.
 */
export function KpiButton({ admin = false, floating = false, header = false }: { admin?: boolean; floating?: boolean; header?: boolean }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} aria-haspopup="dialog"
        className={header
          ? 'inline-flex shrink-0 items-center gap-1 rounded-lg bg-white/20 px-2.5 py-1.5 text-[12px] font-bold text-white ring-1 ring-inset ring-white/30 backdrop-blur active:scale-95'
          : floating
          ? 'fixed bottom-24 left-4 z-30 rounded-full lg:bottom-4 bg-brand-600 px-4 py-3 text-sm font-semibold text-white shadow-lg hover:bg-brand-700'
          : 'btn-ghost px-3 py-1.5 text-sm'}>
        <span aria-hidden="true">📊</span> KPI
      </button>
      {open && <KpiPanel admin={admin} onClose={() => setOpen(false)} />}
    </>
  );
}
